import { Types } from '@store/types';

export const storeNewMsg = (data) => {
	try {
		return {
			type: Types.NEW_INCOMING_MESSAGE_SUCCESS,
			payload: data
		};
	} catch {
		/* Empty Block */
	}
};

export const storeEntityIdForListPage = (data) => {
	try {
		return {
			type: Types.NEW_INCOMING_MESSAGE_IN_LIST_PAGE,
			payload: data
		};
	} catch {
		/* Empty Block */
	}
};

export const clearAllChats = () => {
	try {
		return {
			type: Types.CLEAR_ALL_CHATS
		};
	} catch {
		/* Empty Block */
	}
};

export const storeNewUnreadMention = (data) => {
	try {
		return {
			type: Types.STORE_UNREAD_MENTION,
			payload: data
		};
	} catch {
		/* Empty Block */
	}
};
